// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tc-0";